import utils from '@/utils';

const filters = {
    /**
     * 使用Vue.use时会调用此方法
     * @param vue
     * @param options
     */
    install(vue, options) {
        // 格式化时间YYYY-MM-DD HH:mm:ss
        vue.filter('formatDateTime', utils.formatDateTime);
        // 格式化银行卡号,xxxx xxxx xxxx ...
        vue.filter('formatCardNo', utils.formatCardNo);
        // 转换为中文大写金额
        vue.filter('chineseCurrency', utils.chineseCurrency);
        // 千分金额
        vue.filter('formatMoney', utils.formatMoney);
    }
};

export default filters;
